import { createQueryStringHook } from "../../stores/useQueryState";

export const useVehicleMappingCriteria = createQueryStringHook("q-vehicle", "");
